import ulku_baykal from "../assets/images/instructors/ulku_baykal.jpg";
import eylem_pasli from "../assets/images/instructors/eylem_pasli.jpeg";
import ahmet_nezih_kok from "../assets/images/instructors/ahmet_nezih_kok.jpg";
import seyda_seren_intepeler from "../assets/images/instructors/seyda_seren_intepeler.jpg";
import havva_ozturk from "../assets/images/instructors/havva_ozturk.jpg";
import handan_alan from "../assets/images/instructors/handan_alan.jpg";
import cem_senol from "../assets/images/instructors/cem_senol.jpg";
import husnu_sefa_eryildiz from "../assets/images/instructors/husnu_sefa_eryildiz.jpg";
import bilgehan_savasci_temiz from "../assets/images/instructors/bilgehan_savasci_temiz.jpg";
import ozgur_temiz from "../assets/images/instructors/ozgur_temiz.jpg";

export const instructor_list = [
  {
    name: "Ülkü BAYKAL",
    title: "Prof. Dr.",
    image: ulku_baykal,
    url: "https://akademisyen.arel.edu.tr/portfolio/prof-dr-ulku-baykal",
  },
  {
    name: "Eylem PASLI GÜRDOĞAN",
    title: "Doç. Dr. ",
    image: eylem_pasli,
    url: "https://personel.trakya.edu.tr/eylemgurdogan/",
  },
  {
    name: "Ahmet Nezih KÖK",
    title: "Prof. Dr.",
    image: ahmet_nezih_kok,
    url: "https://avesis.atauni.edu.tr/nezihkok",
  },
  {
    name: "Şeyda SEREN İNTEPELER",
    title: "Prof. Dr.",
    image: seyda_seren_intepeler,
    url: "https://avesis.deu.edu.tr/seyda.seren",
  },
  {
    name: "Havva ÖZTÜRK",
    title: "Prof. Dr.",
    image: havva_ozturk,
    url: "https://avesis.ktu.edu.tr/havvaozturk",
  },
  {
    name: "Handan ALAN",
    title: "Doç. Dr.",
    image: handan_alan,
    url: "https://avesis.iuc.edu.tr/handan.alan",
  },
  {
    name: "Cem ŞENOL",
    title: "Prof. Dr.",
    image: cem_senol,
    url: "https://avesis.atauni.edu.tr/cmsenol",
  },
  {
    name: "Hüsnü Sefa ERYILDIZ",
    title: "Doç. Dr.",
    image: husnu_sefa_eryildiz,
    url: "https://avesis.atauni.edu.tr/sefa.eryildiz",
  },
  {
    name: "Bilgehan SAVAŞCI TEMİZ",
    title: "Dr. Öğr. Üyesi",
    image: bilgehan_savasci_temiz,
    url: "https://avesis.atauni.edu.tr/bilgehan.savasci",
  },
  {
    name: "Özgür TEMİZ",
    title: "Dr. Öğr. Üyesi",
    image: ozgur_temiz,
    url: "https://avesis.atauni.edu.tr/ozgur.temiz/iletisim",
  },
];
